






































































































































import IListCountries from '@/store/models/IListCountries';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class ListCountriesSelector extends Vue {
    searchListCountries: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'countryName';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name', value: 'countryName' },
        { text: 'Code', value: 'code' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IListCountries = {
        id: "",
        countryName: "",
        code: "",
        idCompany: ""
    }
    defaultItem : IListCountries = {
        id: "",
        countryName: "",
        code: "",
        idCompany: ""
    }

    @Prop({ type: Array, required: true })
    ListCountriesList !: IListCountries[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedListCountries : IListCountries[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New Country' : 'Edit Country'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetListCountriess() {
        this.selectedListCountries = [];
    }

    editListCountry (item: any, dbox = true) {
        this.editedIndex = this.ListCountriesList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveListCountry (country: IListCountries) {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedListCountries[0]) {
                this.close();
                this.$emit('editListCountry', this.editedItem);
                Object.assign(this.ListCountriesList[this.editedIndex], this.editedItem);
            } else {
                this.selectedListCountries[0] = this.editedItem;
                this.$emit('saveListCountry', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteListCountry (country: IListCountries) {
        this.$emit('deleteListCountry', country);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectListCountries(item : any) : void {
        if (!this.selectedListCountries.includes(item)) {
            this.selectedListCountries = [];
            this.selectedListCountries = [item];
        } else {
            this.selectedListCountries = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
